import {cloneDeep} from 'lodash';
import {COMPONENT_TYPES} from 'shared/shapes/ComponentPainter';

// preview options are not exclusively boolean
export const getValidStructure = (structures) => {
    let variationRequestStructure; // used to put variation request always last on the list
    let doorStructure; // used to put door form fields always first
    let panelDesignStructure; // used to put panel edging form fields always first
    let drawerPanelStructure;
    let hingeHoleStructure;
    let hasBorders = false;
    let hasBottomBorders = true;
    let hasEdging = true;
    let preview = COMPONENT_TYPES.QFP;
    let hasHorizontalGrain = true;
    let hasDoubleSided = true;
    let hasCustomColour = true;
    let hasCutout = false;
    let hasDoorType = true;
    let hasDrawerFaceHeight = false;
    let isPanel = false;
    let hasDoorHinge = false;
    let hasDoorHang = true;
    let heightField = 'height';
    let widthField = 'width';
    let heightFieldData = null;
    let widthFieldData = null;
    let quantityFieldData = null;
    let isLattice = false;
    let hasDoors = false;
    let hasDrawers = false;
    let hasShelves = false;
    const fieldDisplayNameMap = {};

    const fieldFilter = [
        'cabinet_note',
        'cabinet_panel_length',
        'cabinet_panel_width',
    ];
    const sectionFilter = ['Materials'];
    const fildsetFilter = ['sizes'];

    const validStructure = cloneDeep(structures).filter((structure) => {
        if (structure.name === 'Doors') hasDoors = true;
        if (structure.name === 'Drawers') hasDrawers = true;
        if (structure.name === 'Shelves') hasShelves = true;

        structure.fieldsets = structure.fieldsets.filter((fieldset) => {
            if (!fieldset.hasOwnProperty('options')) fieldset.options = {};
            else fieldset.options.layout = '';

            if (fieldset.qfpTitle) {
                fieldset.title = fieldset.qfpTitle;
            }

            if (fieldset.name === 'additional') {
                fieldset.title = 'Hardware Selections';
            }

            if (fieldset.name === 'cabinet_edges') {
                fieldset.title = 'Panel Edging Design';
            }

            if (fieldset.name === 'advanced_door_glass') {
                fieldset.title = 'Glass Sub Panels';
            }

            if (fieldset.name === 'door_fields') {
                fieldset.title = 'Door Specs';
            }

            if (fieldset.name === 'panes') {
                isLattice = true;
            }

            fieldset.fields = fieldset.fields.filter((field) => {
                field.name = field.name.toLowerCase();
                if (field.displayName && field.displayName != null) {
                    fieldDisplayNameMap[field.name] = fieldset.title
                        ? `${fieldset.title} ${field.displayName}`
                        : field.displayName;
                }

                if (field.name === 'drawer_face_height') {
                    hasDrawerFaceHeight = true;
                }

                if (
                    field.name === 'door_hang' &&
                    field.hasOwnProperty('options') &&
                    field.options.hasOwnProperty('visible')
                ) {
                    hasDoorHang = field.options.visible;
                }

                if (
                    field.name === 'hinge_style' &&
                    field.hasOwnProperty('options') &&
                    field.options.hasOwnProperty('visible')
                ) {
                    hasDoorHinge = field.options.visible;
                } else {
                    hasDoorHinge = false;
                }

                if (field.name.indexOf('edge_l1') > -1) {
                    isPanel = true;
                }

                if (
                    structure.name === 'Materials' &&
                    field.hasOwnProperty('options') &&
                    field.name == 'cabinet_ext_colour'
                ) {
                    if (field.options.hasOwnProperty('horGrainVisible')) {
                        hasHorizontalGrain = field.options.horGrainVisible == 1;
                    }

                    if (field.options.hasOwnProperty('doubleSidedVisible')) {
                        hasDoubleSided = field.options.doubleSidedVisible == 1;
                    }

                    if (field.options.hasOwnProperty('customColourVisible')) {
                        hasCustomColour =
                            field.options.customColourVisible == 1;
                    }
                }

                // need to exclude mid rails as they are having Height as display names
                const midRailsFields = ['vert_width', 'hori_height'];
                if (
                    (field.displayName === 'Height' ||
                        field.displayName === 'Length') &&
                    !midRailsFields.includes(field.name)
                ) {
                    heightField = field.name;
                    heightFieldData = field;
                }

                if (field.displayName === 'Width') {
                    widthField = field.name;
                    widthFieldData = field;
                }

                if (field.name === 'cabinet_quantity') {
                    quantityFieldData = field;
                }

                if (
                    field.name === 'door_hang_type' &&
                    field.hasOwnProperty('options') &&
                    field.options.hasOwnProperty('visible')
                ) {
                    if (
                        field.hasOwnProperty('value') &&
                        field.options.visible == 0
                    ) {
                        hasDoorType = field.value == 1;
                    } else {
                        hasDoorType = field.options.visible;
                    }
                }

                if (
                    field.name == 'border_width_bottom' &&
                    field.options.hasOwnProperty('visible') &&
                    (field.options.visible == 0 ||
                        field.options.visible == false)
                ) {
                    hasBottomBorders = false;
                }

                if (
                    field.name == 'sub_panel' &&
                    field.hasOwnProperty('options') &&
                    field.options.hasOwnProperty('subPanelSettings') &&
                    Array.isArray(field.options.subPanelSettings)
                ) {
                    const allSettings = field.options.subPanelSettings.map(
                        (setting) => setting && setting.enabled == 0
                    );

                    field.options.visible = !(
                        allSettings.length == 9 && allSettings.every(Boolean)
                    );
                }

                return !fieldFilter.includes(field.name);
            });

            if (
                structure.name === 'Doors' &&
                fieldset.name == 'border_widths'
            ) {
                if (
                    fieldset.options &&
                    fieldset.options.visible &&
                    fieldset.options.visible === 'cabinet_door.advanced'
                ) {
                    hasCutout = false;
                } else {
                    hasCutout = true;
                }
            }

            if (structure.name === 'Doors' && fieldset.name == 'mid_rails') {
                const midrailFields = fieldset.fields
                    .map((field) => field.options.visible)
                    .every((value) => value == 0 || value == false);

                if (!midrailFields) {
                    preview = COMPONENT_TYPES.DOOR;
                }
            }

            if (structure.name === 'Doors' && fieldset.name == 'panes') {
                preview = COMPONENT_TYPES.DOOR;
            }

            if (fieldset.name === 'drawer_fields') {
                fieldset.title = 'Drawer Specs';
                const visibleDrawerFields = fieldset.fields
                    .map((field) => field.options.visible)
                    .every((value) => value == 0 || value == false);

                if (!visibleDrawerFields) {
                    preview = COMPONENT_TYPES.DRAWER;
                }
            }

            if (
                preview !== COMPONENT_TYPES.DOOR &&
                fieldset.name === 'advanced_door_glass'
            ) {
                fieldset.options.visible = 0;
            }

            if (fieldset.name == 'comments') {
                variationRequestStructure = fieldset;

                return false;
            }

            if (
                fieldset.name == 'cabinet_edges' ||
                fieldset.name == 'door_edges'
            ) {
                panelDesignStructure = fieldset;

                if (
                    fieldset.options &&
                    fieldset.options.hasOwnProperty('visible')
                ) {
                    hasEdging = fieldset.options.visible;
                }

                const fieldsVisible = fieldset.fields.map(
                    (field) => field.options && field.options.visible
                );

                if (
                    fieldsVisible.every((value) => value == 0) ||
                    fieldsVisible.every((value) => value == false)
                ) {
                    hasEdging = false;
                }

                return false;
            }

            if (fieldset.name == 'drawer_panel_edges') {
                drawerPanelStructure = fieldset;

                return false;
            }

            if (fieldset.name == 'door_drillings') {
                hingeHoleStructure = fieldset;

                return false;
            }

            if (fieldset.name == 'border_widths') {
                if (
                    fieldset.options &&
                    fieldset.options.enabled &&
                    (fieldset.options.enabled == 1 ||
                        fieldset.options.enabled == true)
                ) {
                    hasBorders = true;
                } else {
                    hasBorders = 'cabinet_door.advanced';
                }
            }

            return !fildsetFilter.includes(fieldset.name);
        });

        if (structure.name == 'Doors') {
            doorStructure = structure;

            return false;
        }

        return !sectionFilter.includes(structure.name);
    });

    if (variationRequestStructure) {
        validStructure.push({
            name: 'Comments',
            preview: 'standard',
            fieldsets: [variationRequestStructure],
        });
    }

    if (doorStructure) {
        validStructure.unshift(doorStructure);
    }

    if (panelDesignStructure) {
        const fieldsets = [panelDesignStructure];

        if (drawerPanelStructure) {
            fieldsets.push(drawerPanelStructure);
        }

        validStructure.unshift({
            name: 'Edging',
            preview: 'standard',
            fieldsets: fieldsets,
        });
    }

    validStructure.unshift(getMaterialFields());

    if (hingeHoleStructure) {
        validStructure[2].fieldsets.splice(1, 0, hingeHoleStructure);
    }

    return {
        validStructure,
        hasBorders,
        hasBottomBorders,
        hasEdging,
        preview,
        hasCutout,
        hasDoorType,
        isPanel,
        hasDoorHinge,
        hasDoorHang,
        heightField,
        widthField,
        hasHorizontalGrain,
        hasDoubleSided,
        hasCustomColour,
        hasDrawerFaceHeight,
        heightFieldData,
        widthFieldData,
        quantityFieldData,
        fieldDisplayNameMap,
        isLattice,
        hasDoors,
        hasDrawers,
        hasShelves,
    };
};

const getMaterialFields = () => {
    return {
        name: 'Materials',
        preview: 'standard',
        fieldsets: [
            {
                name: 'material_options',
                title: 'Material Options',
                fields: [
                    {
                        name: 'hor_grain',
                        displayName: 'Horizontal Grain',
                        type: 'boolean',
                        value: null,
                        options: {
                            visible:
                                'AND(cabinet_ext_colour.horGrain, hasHorizontalGrain)',
                        },
                    },
                    {
                        name: 'double_sided',
                        displayName: 'Double Sided',
                        type: 'boolean',
                        value: null,
                        options: {
                            visible:
                                'AND(cabinet_ext_colour.doubleSided, hasDoubleSided)',
                        },
                    },
                    {
                        name: 'custom_colour',
                        displayName: 'Custom Colour',
                        type: 'text',
                        value: null,
                        options: {
                            visible:
                                'AND(cabinet_ext_colour.customColour, hasCustomColour)',
                        },
                    },
                ],
                options: {
                    visible: `OR(AND(cabinet_ext_colour.horGrain, hasHorizontalGrain), AND(cabinet_ext_colour.doubleSided, hasDoubleSided), AND(cabinet_ext_colour.customColour, hasCustomColour))`,
                },
            },
        ],
    };
};
